import React from 'react';

import { AlertTriangleOutline, StarAiFill } from '@lyearn/icons';
import { Button, Input, Popover, PopoverContentPosition, Stack, Typography } from '@lyearn/ui';

function RegenerationWindow({
  children,
  heading,
  buttonText,
  onClick,
  position = 'right-start',
}: {
  children: React.ReactNode;
  heading: string;
  buttonText: string;
  onClick: (value: string) => void;
  position?: PopoverContentPosition;
}) {
  const [value, setValue] = React.useState('');
  const [isPopoverOpen, setIsPopoverOpen] = React.useState(false);

  return (
    <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
      <Popover.Button>{children}</Popover.Button>
      <Popover.Content position={position}>
        <Stack className="w-[28.3rem] p-16" direction="col" gap={16}>
          <Typography variant="heading-xxs">{heading}</Typography>

          <Input
            autoFocus
            multiline
            rows={4}
            value={value}
            onChange={(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
              setValue(event.target.value)
            }
          />

          <Stack direction="col" gap={8}>
            <Stack alignItems="center" direction="row" gap={8}>
              <AlertTriangleOutline fillColorToken="icon-error-light" height={20} width={20} />
              <Typography variant="body-short-02">Attention</Typography>
            </Stack>
            <Typography color="text-text-secondary" variant="body-short-03">
              This will permanently replace the current version.
            </Typography>
          </Stack>

          <Button
            endIcon={<StarAiFill height={16} width={16} />}
            onClick={() => {
              onClick(value);
              setValue('');
              setIsPopoverOpen(false);
            }}>
            {buttonText}
          </Button>
        </Stack>
      </Popover.Content>
    </Popover>
  );
}

export default RegenerationWindow;
